import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import H5 from '@base/H5/H5';
import H6 from '@base/H6/H6';
import P2 from '@base/P2/P2';
import Button from '@base/Button/Button';
import { Spacings, Fonts } from '@styles/index';
import BottomSheet from '@comp/BottomSheet/BottomSheet';
import Coin from '@icon/Coin';

const StyledH6 = styled(H6)`
  text-align: center;
  margin-bottom: ${Spacings.SPACING_3B};
`;

const RequiredCredits = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template: 1fr / repeat(2, max-content);
  grid-column-gap: ${Spacings.SPACING_2B};
  margin-top: ${Spacings.SPACING_5B};
`;

const Value = styled(H5)`
  font-size: 40px;
  line-height: ${Fonts.BUTTON_LINE_HEIGHT};
`;

const TotalContainer = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template: 1fr / repeat(3, max-content);
  grid-column-gap: ${Spacings.SPACING_1B};
  margin: ${Spacings.SPACING_6B} 0px;
`;

const Text = styled(P2)`
  line-height: ${Fonts.BUTTON_LINE_HEIGHT};
`;

const StyledBtn = styled(Button)`
  border-radius: ${Spacings.SPACING_2B};
  background-image: linear-gradient(
    180deg,
    var(--color-i-blue-4) 0%,
    var(--color-i-blue-3) 100%
  );
`;

const EnrollUsingCredits = ({
  show,
  onClose,
  requiredCredits,
  credits,
  enroll
}) => {
  return (
    <BottomSheet open={show} onClose={onClose}>
      <StyledH6>Enroll using credits</StyledH6>
      <RequiredCredits>
        <Coin size="32px" viewBox="0 0 32 32" />
        <Value>{requiredCredits}</Value>
      </RequiredCredits>
      <TotalContainer>
        <Text>You have</Text>
        <Coin size="12px" viewBox="0 0 32 32" />
        <Text>{credits}</Text>
      </TotalContainer>
      <StyledBtn
        grid={5}
        color="green"
        variant="filled"
        label="Enroll now"
        onClick={() => enroll()}
      />
    </BottomSheet>
  );
};

EnrollUsingCredits.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  requiredCredits: PropTypes.number.isRequired,
  credits: PropTypes.number.isRequired,
  enroll: PropTypes.func.isRequired
};

export default EnrollUsingCredits;
